module.exports = __webpack_public_path__ + "img/unicorn-display.33df0cdb.png";